import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../init/getData';

import { Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs } from 'antd';
import Modal from 'react-bootstrap/Modal';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../../components/loader/loader';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../../components/formatters/numberFormatter';

const InvoicejournalVoucher = (props) => {

    const { journalVoucher, setJournalVoucher, validated } = props;

    const { api, userData, settingData, accountData, warehouseData,
        branchData, projectData, currencyData, selectedYear } = useContext(DataContext);


    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);

    const minDate = `${selectedYear?.label}-01-01`;
    const maxDate = `${selectedYear?.label}-12-31`;

    const { showModal, toggleModal, table, title, refreshTable, size, footer, idRow, type } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(true);






    // Account Options
    const accountOptions = accountData?.map(item => ({
        value: item.id,
        label: `${item.chartId}.${item.accountId} ${item.name}`,
        name: item.name,
    }));

    // Load and filter account options
    const loadAccountOptions = (inputValue, callback) => {
        const filteredOptions = inputValue ? accountOptions.filter(option =>
            option.label.toLowerCase().includes(inputValue.toLowerCase())) : [];

        filteredOptions.push({ value: null, label: 'no supplier' });
        callback(filteredOptions);
    };

    // Currency Options
    const currencyOptions = currencyData?.map(item => ({
        value: item.id,
        label: item.code,
        symbol: item.symbol,
        rate: item.rate,
        vatRate: item.vatRate,
    }));


    // warehouse Options
    const warehouseOptions = warehouseData?.map(item => ({
        value: item.id,
        label: item.name,
    }))


    // Branch Options
    const branchOptions = branchData?.map(item => ({
        value: item.id,
        label: item.name,
    }));

    // Project Options
    const projectOptions = projectData?.map(item => ({
        value: item.id,
        label: item.name,
    }))


    // Generic handler for input changes
    const handleInputChange = (e, type) => {
        let { name, value } = e.target;

        if (isNaN(value)) {
        } else {
            value = parseFloat(value);
        }

        if (type == 'boolean') {
            value = JSON.parse(value)
        }

        setJournalVoucher((prev) => ({
            ...prev,
            [name]: value,
        }));
    };




    // handle select change
    const handleSelectChange = (selectedOption, name) => {
        setJournalVoucher((prev) => ({
            ...prev,
            [name]: selectedOption.value,
        }));

        if (name == 'currencyId') {
            setJournalVoucher((prev) => ({
                ...prev,
                rate: selectedOption.rate,
                vatRate: selectedOption.vatRate,
            }));
        }
    };



    return (

        <div>


            <Row className="mb-3">
                <Col>
                    <Form.Label column="sm" sm="4"> Type<span style={{ color: 'red' }}>*</span> </Form.Label>
                    <Form.Select name="isDebit"
                        value={journalVoucher.isDebit}
                        onChange={(e) => handleInputChange(e, 'boolean')}>
                        <option value={'true'}>In</option>
                        <option value={'false'}>Out</option>
                    </Form.Select>
                </Col>


                {/* Date */}
                <Col>
                    <Form.Label>Date<span style={{ color: 'red' }}>*</span></Form.Label>

                    <Form.Control size="sm" type="date" name='date'
                        min={minDate} max={maxDate}
                        value={journalVoucher.date}
                        onChange={(e) => handleInputChange(e, 'text')}
                    />
                </Col>
            </Row>



            <Row className="mb-3">


                {/* Reference */}
                <Col>
                    <Form.Label>Reference#</Form.Label>
                    <Form.Control type="text" name="refNumber"
                        onChange={(e) => handleInputChange(e, 'text')}
                        value={journalVoucher.refNumber} />
                </Col>
                <Col>
                    <Form.Label>warehouse<span style={{ color: 'red' }}>*</span></Form.Label>
                    <Select
                        options={warehouseOptions}
                        isSearchable={true}
                        placeholder="Select"
                        onChange={(e) => handleSelectChange(e, 'warehouseId')}
                        value={warehouseOptions?.find(option => option.value === journalVoucher.warehouseId) || []}
                        required
                    />
                </Col>
            </Row>



        </div>

    )
}


export default InvoicejournalVoucher;